<template>
    <div class="common_page_div">
        <div style="margin-bottom: 100px; display: flex">
            <div style="margin-left: 100px; width:50%">
                <div style="padding-bottom: 20px">
                    <div style="padding-bottom: 20px">
                        URL:<input type="text" v-model="api_url" style="width:300px">
                    </div>
                    <!--<div style="padding-bottom: 20px">-->
                        <!--DATA:<input type="text" v-model="post_data" style="width:300px">-->
                    <!--</div>-->
                    <div style="padding-bottom: 20px">
                        <button @click="test_get">get测试</button>
                        <button @click="test_post">post测试</button>
                        <button @click="data_reload">刷新数据</button>
                    </div>
                    <div style="word-wrap:break-word;padding-bottom: 20px;white-space: pre-line;">
                        返回状态码：{{ result_status }}
                    </div>
                    <div style="word-wrap:break-word;padding-bottom: 20px">
                        返回：{{ api_result }}
                    </div>
                    <div style="word-wrap:break-word;padding-bottom: 20px">
                        header：{{ api_result_header }}
                    </div>
                </div>
            </div>
            <div style="margin-left: 100px; width:50%">
                <h3>浮动薪酬项计算</h3>
                <div style="margin-bottom: 20px">
                    <p>分配计算</p>
                    <span v-for="(s_info, s_index) in salary_types" :key="s_index" style="margin-right: 20px">{{s_info['type']}}</span>
                    <p>
                        薪酬项类型:<input type="text" v-model="input_salary_type" style="width:300px">
                    </p>
                    <p>
                        薪酬项id:<input type="text" v-model="input_salary_id" style="width:300px">
                    </p>
                    <button @click="calc_salary_amount">计算总额</button>
                    <button @click="salary_distribution">分配金额</button>
                </div>
                <div style="margin-bottom: 20px">
                    <p>多薪酬项计算</p>
                    <p>
                        参照薪酬分配项id:<input type="text" v-model="float_salary_base" style="width:300px">
                    </p>
                    <p>
                        薪酬分配项id:<input type="text" v-model="float_salary_id" style="width:300px">
                    </p>
                    <button @click="set_distribution_by_float_ratio">计算薪酬项</button>
                </div>

            </div>
        </div>


        <div>
            <div style="margin-bottom: 100px; display: flex">
                <div style="margin-left: 100px; width:50%">
                    <h3>Persons</h3>
                    <div>
                        <span style="margin-left: 20px">id</span>
                        <span style="margin-left: 20px">名称</span>
                        <span style="margin-left: 20px">职位</span>
                        <span style="margin-left: 20px">往期薪资</span>
                        <span style="margin-left: 20px">固定薪酬额</span>
                        <span style="margin-left: 20px">浮动薪酬额</span>
                        <span style="margin-left: 20px">薪酬总额</span>
                    </div>
                    <div v-for="(person, index_p) in persons" :key="index_p">
                        <span style="margin-left: 20px">{{ person.id }}</span>
                        <span style="margin-left: 20px">{{ person.name }}</span>
                        <span style="margin-left: 20px">{{ person.position_name }}</span>
                        <span style="margin-left: 20px">{{ person.salary_before }}</span>
                        <span style="margin-left: 20px">{{ person.fixed_salary_amount }}</span>
                        <span style="margin-left: 20px">{{ person.float_salary_amount }}</span>
                        <span style="margin-left: 20px">{{ person.salary_amount }}</span>
                    </div>
                </div>
                <div style="margin-left: 100px; width:50%">
                    <h3>Positions</h3>
                    <div>
                        <span style="margin-left: 20px">id</span>
                        <span style="margin-left: 20px">名称</span>
                        <span style="margin-left: 20px">黑箱因子</span>
                        <span style="margin-left: 20px">市场金额</span>
                    </div>
                    <div v-for="(position, index_pos) in positions" :key="index_pos">
                        <span style="margin-left: 20px">{{ position.id }}</span>
                        <span style="margin-left: 20px">{{ position.name }}</span>
                        <span style="margin-left: 20px">{{ position.black_box_factor }}</span>
                        <span style="margin-left: 20px">{{ position.market_value }}</span>
                    </div>
                </div>
            </div>
            <div style="margin-bottom: 100px; display: flex">
                <div style="margin-left: 100px; width:50%">
                    <h3>Salaries</h3>
                    <div v-for="(t, index_t) in salary_types" :key="index_t" style="border: solid 1px">
                        <h4>{{t['name']}}</h4>
                        <div>
                            <span style="margin-left: 20px">id</span>
                            <span style="margin-left: 20px">名称</span>
                            <span style="margin-left: 20px">基数</span>
                            <span style="margin-left: 20px">系数</span>
                            <span style="margin-left: 20px">总额</span>
                        </div>
                        <div v-for="(salary, index_s) in salaries[t['type']]" :key="index_s" style="margin-bottom: 20px;border: solid 1px">
                            <span style="margin-left: 20px">{{ salary.id }}</span>
                            <span style="margin-left: 20px">{{ salary.name }}</span>
                            <span style="margin-left: 20px">{{ salary.base_amount }}</span>
                            <span style="margin-left: 20px">{{ salary.ratio }}</span>
                            <span style="margin-left: 20px">{{ salary.amount }}</span>
                            <p style="margin-left: 40px;margin-top: 20px">人员分配名单:</p>
                            <div>
                                <span style="margin-left: 20px">id</span>
                                <span style="margin-left: 20px">人员id</span>
                                <span style="margin-left: 20px">人员名称</span>
                                <span style="margin-left: 20px">金额</span>
                                <span style="margin-left: 20px">占比</span>
                                <span style="margin-left: 20px">多浮动项占比</span>
                            </div>
                            <div v-for="(dis, index_dis) in salary.distribution_infos" :key="index_dis">
                                <span style="margin-left: 20px">{{ dis.id }}</span>
                                <span style="margin-left: 20px">{{ dis.person_id }}</span>
                                <span style="margin-left: 20px">{{ dis.person_name }}</span>
                                <span style="margin-left: 20px">{{ dis.amount }}</span>
                                <span style="margin-left: 20px">{{ dis.rate }}</span>
                                <span style="margin-left: 20px">{{ dis.person_floats_ratio }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="margin-left: 100px; width:50%">
                    <h3>Black Box</h3>
                    <div style="padding-bottom: 20px">
                        BlackBoxId:<input type="text" v-model="black_box_id" style="width:300px">
                    </div>
                    <div style="padding-bottom: 20px">
                        BlackBoxAmount:<input type="text" v-model="black_box_amount" style="width:300px">
                    </div>
                    <div style="padding-bottom: 20px">
                        <button @click="black_box_send">发送黑箱请求</button>
                        <button @click="black_box_set">按照黑箱数据设置</button>
                    </div>
                    <div style="padding-bottom: 20px">
                        是否需要设置比例<span>{{black_box_data.if_need_set_float_ratio}}</span>
                        最大值：<span>{{black_box_data.max}}</span>
                        最小值：<span>{{black_box_data.min}}</span>
                        平均值：<span>{{black_box_data.average}}</span>
                        同职位平均值：<span>{{black_box_data.position_average}}</span>
                    </div>
                    <div v-if="black_box_data.selections">
                        <p>所有参照列表</p>
                        <div v-for="(select, b_index) in black_box_data.selections" :key="b_index">
                            参照人id<span style="margin-left: 20px;margin-right: 20px">{{ select.person_id }}</span>
                            参照人薪酬总额<span style="margin-left: 20px;margin-right: 20px">{{ select.amount }}</span>
                            推荐总额<span style="margin-left: 20px;margin-right: 20px">{{ select.calc_amount }}</span>
                            推荐浮动额<span style="margin-left: 20px;margin-right: 20px">{{ select.float_amount }}</span>
                        </div>
                    </div>
                    <div v-if="black_box_data.position_selections" style="margin-top: 30px">
                        <p>按职位参照列表</p>
                        <div v-for="(position_info, position_id) in black_box_data.position_selections" :key="position_id">
                            职位id：{{position_id}}
                            <div v-for="(select, p_b_index) in position_info" :key="p_b_index">
                                参照人id<span style="margin-left: 20px;margin-right: 20px">{{ select.person_id }}</span>
                                参照人薪酬总额<span style="margin-left: 20px;margin-right: 20px">{{ select.amount }}</span>
                                推荐总额<span style="margin-left: 20px;margin-right: 20px">{{ select.calc_amount }}</span>
                                推荐浮动额<span style="margin-left: 20px;margin-right: 20px">{{ select.float_amount }}</span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">

import { mapActions } from 'vuex'
import api_sender from '@/api/api_test/api_test.js'

export default {
    data() {
        return {
            api_url:'',
            result_status:'',
            post_data:'',
            api_result: '',
            api_result_header:'',
            persons: [],
            positions: [],
            salaries: {},
            salary_types: {},
            black_box_id: '',
            black_box_amount: 0,
            black_box_data: {},
            input_salary_type: '',
            input_salary_id: '',
            float_salary_base: '',
            float_salary_id: '',
        }
    },
    mounted: function () {
        this.data_reload()
    },
    methods: {
        ...mapActions({

        }),
        async data_reload(){
            let that = this
            api_sender.get_persons().then((res)=>{
                if (res.status === 200 && res.data.code === 'success'){
                    that.persons = res.data.result
                    console.log(res.data.result)
                }
            })
            api_sender.get_salary_types().then((res)=>{
                if (res.status === 200 && res.data.code === 'success'){
                    that.salary_types = res.data.result
                }
            })
            api_sender.get_salaries().then((res)=>{
                if (res.status === 200 && res.data.code === 'success'){
                    that.salaries = res.data.result
                }
            })
            api_sender.get_positions().then((res)=>{
                console.log(res)
                if (res.status === 200 && res.data.code === 'success'){
                    that.positions = res.data.result
                }
            })
        },
        async black_box_send(){
            console.log('post=>','black_box_send')
            api_sender.get_black_box_selections({
                'distribution_id': this.black_box_id,
            }).then((res)=>{
                if (res.status === 200){
                    let result = JSON.parse(res.data.result)
                    console.log(result)
                    if (result.code === 'success'){
                        this.black_box_data = result.result
                    }
                }
            })
        },
        async calc_salary_amount(){
            console.log('post=>','calc_salary_amount')
            let that = this
            api_sender.calc_salary_amount({
                'salary_type': this.input_salary_type,
                'salary_id': this.input_salary_id,
            }).then((res)=>{
                if (res.status === 200){
                    let result = JSON.parse(res.data.result)
                    if (result.code === 'success'){
                        that.salaries[that.input_salary_type].forEach((salary)=>{
                            if (salary.id === Number(this.input_salary_id)){
                                console.log(salary, result)
                                salary.amount = result.result.amount
                            }
                        })
                    }
                }
            })
        },
        async salary_distribution(){
            console.log('post=>','salary_distribution')
            let that = this
            api_sender.salary_distribution({
                'salary_type': this.input_salary_type,
                'salary_id': this.input_salary_id,
            }).then((res)=>{
                if (res.status === 200){
                    let result = JSON.parse(res.data.result)
                    if (result.code === 'success'){
                        that.salaries[that.input_salary_type].forEach((salary)=>{
                            if (salary.id === Number(this.input_salary_id)){
                                salary.distribution_infos = result.result
                            }
                        })
                    }
                }
            })
        },
        async set_distribution_by_float_ratio(){
            console.log('post=>','set_distribution_by_float_ratio')
            api_sender.set_distribution_by_float_ratio({
                'distribution_based': this.float_salary_base,
                'distribution_id': this.float_salary_id,
            }).then((res)=>{
                if (res.status === 200){
                    let result = JSON.parse(res.data.result)
                    console.log(result)
                    // if (result.code === 'success'){
                    //     this.black_box_data = result.result
                    // }
                }
            })
        },
        async black_box_set(){
            console.log('post=>','black_box_set')
            api_sender.set_by_black_box({
                'distribution_id': this.black_box_id,
                'float_salary_amount': this.black_box_amount,
            }).then((res)=>{
                if (res.status === 200){
                    let result = JSON.parse(res.data.result)
                    console.log(result)
                    // if (result.code === 'success'){
                    //     this.black_box_data = result.result
                    // }
                }
            })
        },
        async test_get(){
            console.log('get=>',this.api_url)
            if (this.api_url){
                api_sender.test_get(this.api_url).then((res)=>{
                    this.result_status = res.status
                    if (res.status === 200 || res.status === 204){
                        this.api_result = res.data.result
                        if (res.status === 204){
                            this.api_result = res
                        }
                        this.api_result_header = res.headers
                    }else{
                        this.api_result = res
                        alert('出错了' + this.status)
                    }
                })
            }

        },
        async test_post(){
            console.log('post=>',this.api_url)
            // // salary/create_positions
            // this.post_data = {
            //     'positions': [{
            //         'name': '123',
            //         'black_box_factor': 1.1,
            //         'market_value': 200000,
            //     }],
            // }
            // // salary/create_persons
            // this.post_data = {
            //     'persons': [{
            //         'name': 'zf',
            //         'position_id': 77,
            //         'salary_before': 100000,
            //         'float_rate': 0.5,
            //         'fixed_salary_id': 18,
            //         'distribution_ids': [304, 312],
            //     },{
            //         'name': 'zf2',
            //         'position_id': 77,
            //         'salary_before': 120000,
            //         'float_rate': 0.7,
            //         'fixed_salary_id': 18,
            //         'distribution_ids': [303,],
            //     }],
            // }
            // // salary/update_persons
            // this.post_data = {
            //     'persons': [{
            //         'id': 306,
            //         'name': 'chise',
            //         'position_id': 76,
            //         'salary_before': 110000,
            //         'float_rate': 0.5,
            //         'fixed_salary_id': 18,
            //         'distribution_ids': [304],
            //     },{
            //         'id':307,
            //         'name': '张帆',
            //         'position_id': 78,
            //         'salary_before': 130000,
            //         'float_rate': 0.7,
            //         'fixed_salary_id': 18,
            //         'distribution_ids': [303,],
            //     }],
            // }
            // // salary/create_salaries
            // this.post_data = {
            //     'ujoyer.salary.float.commission': [{
            //         'name': '佣金制5',
            //         'base_amount': 10000000,
            //         'ratio': 1,
            //         'person_ids': [306,307],
            //     }],
            //     'ujoyer.salary.float.merit': [{
            //         'name': '绩效工资3',
            //         'person_ids': [305,306,307],
            //     }]
            // }
            // // salary/update_salaries
            // this.post_data = {
            //     'ujoyer.salary.float.commission': [{
            //         'id':61,
            //         'name': '佣金制6532544',
            //         'base_amount': 24053450,
            //         'ratio': 0.01,
            //         'person_ids': [306,307],
            //     }],
            //     'ujoyer.salary.float.merit': [{
            //         'id':21,
            //         'name': '绩效工资2632534',
            //         'person_ids': [305,288],
            //     }]
            // }
            // // salary/set_distribution_rates
            // this.post_data = {
            //     'salary_type': 'ujoyer.salary.float.commission',
            //     'salary_id': 54,
            //     'rates': {252: 0.43, 253:0.57},
            // }
            // // salary/create_factors
            // this.post_data = {
            //     'salary_type': 'ujoyer.salary.float.commission',
            //     'salary_id': 62,
            //     'factors': [
            //         {'name': '乘积因子1', 'factor_type': 'ujoyer.salary.factor.product', 'amount': 1.1},
            //         {'name': '加减因子1', 'factor_type': 'ujoyer.salary.factor.plus', 'amount': 100000}],
            // }
            // // salary/update_factors
            // this.post_data = {
            //     'ujoyer.salary.factor.product': [{
            //         'id': 4,
            //         'amount': 1,
            //     },],
            //     'ujoyer.salary.factor.plus':[{
            //         'id': 4,
            //         'amount': 10,
            //         'name': '加减因子1234123',
            //     },]
            // }
            // // salary/set_person_floats_ratios
            // this.post_data = {
            //     'person_id': 267,
            //     'ratios':
            //         {
            //             '259': 3,
            //             '266': 1,
            //         },
            // }
            // // salary/calc_salary_amount, salary/salary_distribution
            // this.post_data = {
            //     'salary_type': 'ujoyer.salary.float.commission',
            //     'salary_id': 65,
            // }
            // this.post_data = {
            //     'salary_type': 'ujoyer.salary.float.commission',
            //     'salary_id': 52,
            // }
            // // salary/set_distribution_by_float_ratio
            // this.post_data = {
            //     'distribution_based': 336,
            //     'distribution_id': 343,
            // }
            // // salary/get_black_box_selections, salary/if_black_box_work
            // this.post_data = {
            //     'distribution_id': 311,
            // }
            // salary/set_distribution_by_black_box
            this.post_data = {
                'distribution_id': 345,
                'float_salary_amount': 46000,
            }

            if (this.api_url){
                api_sender.test_post(this.api_url, this.post_data).then((res)=>{
                    this.result_status = res.status
                    console.log(res)
                    if (res.status === 200 || res.status === 204){
                        this.api_result = res.data.result
                        if (res.status === 204){
                            this.api_result = res
                        }
                        this.api_result_header = res.headers
                    }else{
                        this.api_result = res
                        alert('出错了' + this.status)
                    }
                })
            }
        },
    },
}
</script>
<style type="text/css">

</style>
